import React from 'react';
import { useTranslation } from 'react-i18next';
import { useWindowDimensions } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

type EmptyGamesMessageProps = {
    title?: string;
    description?: string;
};

export const EmptyGamesMessage = ({ title, description }: EmptyGamesMessageProps) => {
    const { t } = useTranslation('casino');
    const { height: defaultHeight } = useWindowDimensions();
    const height = defaultHeight - 200;

    return (
        <Box px="s32" flex={1} height={height} justifyContent="center" alignItems="center">
            <Text variant="titleLarge" mb="s8">
                {title ?? t('no_games_available')}
            </Text>
            <Text variant="bodyMedium" color={ds.colorToken.text.secondary} textAlign="center">
                {description ?? t('no_games_available_description')}
            </Text>
        </Box>
    );
};
